/**
 * 마크다운 구문을 제거하고 순수 텍스트만 반환합니다.
 * TTS(Text-to-Speech)에서 자연스럽게 읽을 수 있도록 처리합니다.
 *
 * @param markdown - 마크다운 형식의 텍스트
 * @returns 마크다운이 제거된 순수 텍스트
 *
 * @example
 * ```ts
 * stripMarkdown("**Hello** World") // "Hello World"
 * stripMarkdown("[Link](https://example.com)") // "Link"
 * stripMarkdown("# Title\n\nContent") // "Title Content"
 * ```
 */
export const stripMarkdown = (markdown: string): string => {
  if (!markdown) return "";

  let text = markdown;

  // 1. 코드 블록 제거 (```...```)
  text = text.replace(/```[\s\S]*?```/g, "");

  // 2. 인라인 코드 제거 (`code`)
  text = text.replace(/`([^`]+)`/g, "$1");

  // 3. 이미지 제거 (![alt](url))
  text = text.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");

  // 4. 링크 제거 ([text](url) → text)
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

  // 5. 볼드/이탤릭 제거 (**, __, *, _)
  text = text.replace(/(\*\*|__)(.*?)\1/g, "$2");
  text = text.replace(/(\*|_)(.*?)\1/g, "$2");

  // 6. 헤딩 제거 (# ## ### 등)
  text = text.replace(/^#{1,6}\s+/gm, "");

  // 7. 수평선 제거 (---, ***, ___)
  text = text.replace(/^[-*_]{3,}\s*$/gm, "");

  // 8. 목록 마커 제거 (-, *, +, 1. 2. 등)
  text = text.replace(/^[*\-+]\s+/gm, "");
  text = text.replace(/^\d+\.\s+/gm, "");

  // 9. 인용 제거 (>)
  text = text.replace(/^>\s+/gm, "");

  // 10. HTML 태그 제거 (<tag>)
  text = text.replace(/<[^>]+>/g, "");

  // 11. 특수 문자 제거 (|, ~, 등)
  text = text.replace(/\|/g, " ");
  text = text.replace(/~~/g, "");

  // 12. 연속된 공백을 하나로
  text = text.replace(/\s+/g, " ");

  // 13. 연속된 줄바꿈을 하나로
  text = text.replace(/\n{3,}/g, "\n\n");

  // 14. 앞뒤 공백 제거
  text = text.trim();

  return text;
};
